import { render, staticRenderFns } from "./EventContactPromoterModalComponent.vue?vue&type=template&id=4b2be6f6&"
import script from "./EventContactPromoterModalComponent.vue?vue&type=script&lang=ts&"
export * from "./EventContactPromoterModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports